import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=983dbc84&scoped=true&"
import script from "./chip.vue?vue&type=script&lang=js&"
export * from "./chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983dbc84",
  null
  
)

export default component.exports